/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_settings_no_providers = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No OAuth providers configured on the server.`)
};

const zh_hans1_settings_no_providers = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`服务器未配置 OAuth 提供商。`)
};

const zh_hant1_settings_no_providers = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`伺服器未設定 OAuth 供應商。`)
};

const fr_settings_no_providers = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun fournisseur OAuth configuré sur le serveur.`)
};

const de_settings_no_providers = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine OAuth-Provider auf dem Server konfiguriert.`)
};

const ja_settings_no_providers = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サーバーに OAuth プロバイダーが設定されていません。`)
};

const ko_settings_no_providers = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`서버에 OAuth 제공자가 구성되어 있지 않습니다.`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const settings_no_providers = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.settings_no_providers(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("settings_no_providers", locale)
	if (locale === "en") return en_settings_no_providers(inputs)
	if (locale === "zh-Hans") return zh_hans1_settings_no_providers(inputs)
	if (locale === "zh-Hant") return zh_hant1_settings_no_providers(inputs)
	if (locale === "fr") return fr_settings_no_providers(inputs)
	if (locale === "de") return de_settings_no_providers(inputs)
	if (locale === "ja") return ja_settings_no_providers(inputs)
	return ko_settings_no_providers(inputs)
};